import { tv, type VariantProps } from 'tailwind-variants';

export type MlCardVariants = VariantProps<typeof mlCardVariants>;

const mlCardVariants = tv({
  slots: {
    base: 'bg-skin-primary h-full block flex-col box-border relative overflow-hidden',
    icon: 'h-35 w-35',
    textContainer: 'box-border',
    mainImage: 'relative h-165 w-full',
    header: 'text-skin-secondary',
    tag: 'rounded-2xl p-2 box-border',
    cta: 'mt-12 inline-block text-xl',
    chip: 'bg-chiclet-offers rounded-full px-4 py-3 flex gap-2 items-center justify-center font-medium',
    bodyContent: 'text-surface-tertiary paragraph-md',
    contentWrapper: '',
  },
  variants: {
    selected: {
      true: '',
      false: '',
    },
    theme: {
      light: 'theme-light',
      dark: 'theme-dark',
    },
    alignment: {
      left: {
        base: 'items-start text-left',
        header: 'text-left',
        bodyContent: 'text-left',
      },
      center: {
        base: 'items-center text-center',
        header: 'text-center',
        bodyContent: 'text-center',
      },
      right: {
        base: 'items-end text-right',
        header: 'text-right',
        bodyContent: 'text-right',
      },
    },
    backgroundColor: { red: 'bg-skin-error' },
    type: {
      infographic: {
        base: 'rounded-30 px-11 flex justify-start flex-row md:flex-col',
        icon: 'mb-8 mr-3 min-w-fit w-6 md:mr-0',
        header: 'mb-12 font-Thermal',
        bodyContent: '!text-skin-tertiary',
      },
      image: {
        base: 'rounded-30 shadow-card pb-11',
        textContainer: 'pt-11 pl-11 pr-11',
        header: 'font-Thermal font-medium',
        mainImage: '[&_img]:rounded-t-30',
      },
      full_image: {
        base: 'rounded-30 shadow-card',
        textContainer:
          'p-7.5 pr-62 z-10 relative text-skin-primary h-full flex items-end font-Figtree',
        header: 'font-medium text-skin-primary',
        mainImage: '[&_img]:rounded-30 absolute w-full h-full',
      },
      icon: {
        base: 'rounded-30 flex p-11 justify-center',
        icon: 'mb-6',
        header: 'font-Thermal font-medium',
      },
      'home-plan': {
        base: 'w-full',
        mainImage:
          '[&_figure_img]:rounded-30 [&_figure>div]:rounded-30 h-[12rem] md:h-[20.56rem]  mb-5.2 md:mb-9',
      },
      promo: {
        base: 'rounded-30 justify-center p-12 md:py-24 md:px-14',
        chip: 'text-xl inline-flex gap-1.5',
        cta: 'mt-6 md:mt-9',
        header: 'my-6 md:mb-18 md:mt-9 text-skin-primary',
        bodyContent: 'text-skin-tertiary',
      },
      'promo-compact': {
        base: 'rounded-30 justify-center p-12',
        chip: 'bg-chiclet-offers text-xl inline-flex gap-1.5',
        cta: 'mt-6 md:mt-9',
        header: 'my-6 md:mb-18 md:mt-12 text-skin-primary',
        bodyContent: 'text-skin-tertiary',
      },
      'simple-action': {
        base: 'flex px-16 justify-center',
        header: 'text-skin-tertiary mt-12',
      },
      'stat-card': {
        base: 'rounded-[1.875rem] bg-transparent flex flex-row lg:items-center focus:ring-2 focus:ring-black focus:ring-offset-white focus:bg-white focus-visible:outline-none',
        header: '!mb-0 !pb-2  text-22  mt-4 px-4 lg:mb-3 lg:mt-0 lg:p-0 ',
        bodyContent: 'link-text-sm text-sm px-4 font-semibold  lg:p-0',
        mainImage: 'h-120 w-full',
        contentWrapper: 'flex w-full items-center',
      },
    },
  },
  compoundVariants: [
    {
      type: 'stat-card',
      selected: false,
      class: {
        mainImage:
          'max-w-180 mr-3 [&_img]:rounded-3xl flex-shrink-0 p-1 md:pl-2',
      },
    },
    {
      type: 'stat-card',
      selected: true,
      class: {
        base: 'bg-skin-surface-primary bg-white pb-4 flex-col justify-center lg:justify-start lg:flex-row lg:p-4 focus:border-2 focus:border-black',
        mainImage:
          'lg:max-w-180 [&_img]:rounded-t-[1.875rem] [&_img]:rounded-b-none lg:[&_img]:rounded-3xl lg:mr-3',
        contentWrapper: 'flex-col lg:flex-row',
      },
    },
  ],
});

export default mlCardVariants;
